import { useEffect, useRef } from "react";
import type { ReactNode } from "react";
import { useCardCanvasStore } from "@/components/studio/useCardCanvasStore";
import type { CardUnion } from "./types";

export function EnvelopeRenderer({ card, children }: { card: CardUnion; children: ReactNode }) {
  const lastPushedId = useRef<string | null>(null);
  const push = useCardCanvasStore((s) => s.push);

  useEffect(() => {
    if (lastPushedId.current === card.card_id) return;
    lastPushedId.current = card.card_id;
    push(card);
  }, [card, push]);

  return <>{children}</>;
}
